export default __webpack_public_path__ + "static/media/icon_reportProcessing.efc0a545.gif";